// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/ABCWhyteInktrap-Book.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "WhyteInktrap";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype");
}
* {
  box-sizing: border-box;
  font-family: "Inter", sans-serif;
}

html, body {
  color: #222228;
}

.datePicker {
  height: 40px;
}
.datePicker .react-datepicker__input-container {
  height: 100%;
}

.react-datepicker__triangle path {
  fill: #60748E;
  stroke: #60748E;
}

.react-datepicker {
  font-family: "Inter", sans-serif, sans-serif;
  border-radius: 8px;
  border: 1px solid #EAECF0;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);
}
.react-datepicker .react-datepicker__navigation-icon::before {
  border-color: #FFFFFF;
}
.react-datepicker .react-datepicker__header {
  background-color: #60748E;
  border-bottom: 1px solid #EAECF0;
}
.react-datepicker .react-datepicker__header .react-datepicker__current-month {
  font-weight: 500;
  color: #FFFFFF;
}
.react-datepicker .react-datepicker__day-names > .react-datepicker__day-name {
  color: #FFFFFF;
}
.react-datepicker .react-datepicker__day {
  color: #222228;
}
.react-datepicker .react-datepicker__day--selected {
  background-color: #DDEAFB;
  color: #222228;
}
.react-datepicker .react-datepicker__day--in-selecting-range {
  background-color: #DDEAFB;
  color: #222228;
}
.react-datepicker .react-datepicker__day--in-range {
  background-color: #DDEAFB;
  color: #222228;
}
.react-datepicker .react-datepicker__day--keyboard-selected:hover {
  background-color: #DDEAFB;
}

.react-datepicker__input-container .react-datepicker__calendar-icon {
  padding: 13px 0 0 8px !important;
}

.react-datepicker__close-icon::after {
  background-color: #60748E;
  height: 12px;
  width: 12px;
}

.customInput {
  font-family: "Inter", sans-serif, sans-serif;
  padding: 0 30px;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #EAECF0;
  margin: 0 auto;
  background-color: #FFFFFF;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  white-space: nowrap;
}

.custom-input:focus {
  outline: none;
}

.calendarIcon {
  position: absolute;
  left: 6px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
}`, "",{"version":3,"sources":["webpack://./src/core/styles.scss","webpack://./src/components/DateFilter/DateFilter.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;EACA,+DAAA;ACCF;AD0BA;EACE,sBAAA;EACA,gCAzBS;ACCX;;AD2BA;EACE,cAVY;ACdd;;AATA;EACE,YAAA;AAYF;AAVE;EACE,YAAA;AAYJ;;AAPE;EACE,aDCO;ECAP,eAAA;AAUJ;;AANA;EACE,4CAAA;EACA,kBAAA;EACA,yBAAA;EACA,4CAAA;AASF;AAPE;EACE,qBDGI;ACMR;AANE;EACE,yBDfO;ECgBP,gCAAA;AAQJ;AANI;EACE,gBAAA;EACA,cDNE;ACcR;AAJE;EACE,cDXI;ACiBR;AAHE;EACE,cDjBU;ACsBd;AAFE;EACE,yBDpCQ;ECqCR,cDtBU;AC0Bd;AAFE;EACE,yBDxCQ;ECyCR,cD1BU;AC8Bd;AADE;EACE,yBD7CQ;EC8CR,cD/BU;ACkCd;AAAE;EACE,yBDlDQ;ACoDZ;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,yBDxDS;ECyDT,YAAA;EACA,WAAA;AACF;;AAEA;EACE,4CAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,yBDtDM;ECuDN,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;AACF","sourcesContent":["@font-face {\n  font-family: 'WhyteInktrap';\n  src: url('./../assets/fonts/ABCWhyteInktrap-Book.otf') format('opentype');\n}\n\n//FONTS\n$mainFont: 'Inter', sans-serif;\n$secondaryFont: 'WhyteInktrap', sans-serif;\n\n// COLORS\n$lightBlue: #DDEAFB;\n$mediumBlue: #B4E1FA;\n$blue: #23A0E5;\n$darkBlue: #60748E;\n$lightGrey: #EAECF0;\n$lightOrange: rgba(250, 182, 145, 0.76);\n$orange: #FF7427;\n$red: #C60C30;\n$plusGreen: #EBFF99;\n$lightGreen: #7ADDAF;\n$green: #007940;\n$darkGreen: #112C22;\n$purple: #D7B7FF;\n$lightPurple: #DBD7FC;\n\n$primaryDark: #222228;\n$secondaryDark: #122D62;\n$white: #FFFFFF;\n\n* {\n  box-sizing: border-box;\n  font-family: $mainFont;\n}\n\nhtml, body {\n  color: $primaryDark;\n}","@import '../../core/styles';\n\n.datePicker {\n  height: 40px;\n\n  .react-datepicker__input-container {\n    height: 100%;\n  }\n}\n\n.react-datepicker__triangle {\n  path {\n    fill: $darkBlue;\n    stroke: $darkBlue;\n  }\n}\n\n.react-datepicker {\n  font-family: $mainFont, sans-serif;\n  border-radius: 8px;\n  border: 1px solid $lightGrey;\n  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);\n\n  .react-datepicker__navigation-icon::before {\n    border-color: $white;\n  }\n\n  .react-datepicker__header {\n    background-color: $darkBlue;\n    border-bottom: 1px solid $lightGrey;\n\n    .react-datepicker__current-month {\n      font-weight: 500;\n      color: $white;\n    }\n  }\n\n  .react-datepicker__day-names > .react-datepicker__day-name{\n    color: $white;\n  }\n\n  .react-datepicker__day {\n    color: $primaryDark;\n  }\n\n  .react-datepicker__day--selected {\n    background-color: $lightBlue;\n    color: $primaryDark;\n  }\n  .react-datepicker__day--in-selecting-range {\n    background-color: $lightBlue;\n    color: $primaryDark;\n  }\n\n  .react-datepicker__day--in-range {\n    background-color: $lightBlue;\n    color: $primaryDark;\n  }\n\n  .react-datepicker__day--keyboard-selected:hover {\n    background-color: $lightBlue;\n  }\n}\n\n.react-datepicker__input-container .react-datepicker__calendar-icon {\n  padding: 13px 0 0 8px !important;\n}\n\n.react-datepicker__close-icon::after {\n  background-color: $darkBlue;\n  height: 12px;\n  width: 12px;\n}\n\n.customInput {\n  font-family: $mainFont, sans-serif;\n  padding: 0 30px;\n  height: 40px;\n  border-radius: 8px;\n  border: 1px solid $lightGrey;\n  margin: 0 auto;\n  background-color: $white;\n  cursor: pointer;\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  white-space: nowrap;\n}\n\n.custom-input:focus {\n  outline: none;\n}\n\n.calendarIcon {\n  position: absolute;\n  left: 6px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 20px;\n  height: 20px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
